import { AsyncPipe, NgFor, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { NavigationComponent } from '@shared/components/navigation';
import { QnAReply, selectAuthInfo } from '@shared/store';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { MarkdownModule } from 'ngx-markdown';
import { AvatarComponent, TimeAgoPipe } from 'thkee-common';

@Component({
  selector: 'app-qa-a-card',
  templateUrl: './qa-a-card.component.html',
  styleUrls: ['./qa-a-card.component.scss'],
  standalone: true,
  imports: [
    NgFor,
    NgIf,
    AsyncPipe,
    AngularSvgIconModule,
    TimeAgoPipe,
    AvatarComponent,
    MarkdownModule,
    NavigationComponent,
  ],
})
export class QaACardComponent {
  authUser$ = this.store.select(selectAuthInfo);
  @Input() data!: QnAReply;
  @Output() selectDropDownEvent = new EventEmitter<Object>();

  constructor(private store: Store) {}

  emitClickEvent(action: string, id: string, comment: string) {
    if (action === 'edit-comment') {
      this.selectDropDownEvent.emit({ action: action, id: id, comment: comment });
    } else {
      this.selectDropDownEvent.emit({ action: action, id: id });
    }
  }
}
